import { render, staticRenderFns } from "./ProcedureInternes.vue?vue&type=template&id=c6e55f94&"
import script from "./ProcedureInternes.vue?vue&type=script&lang=js&"
export * from "./ProcedureInternes.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureInternes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports